export default __webpack_public_path__ + "static/media/run.696e7969.svg";